import { BaseModel, fillOwnProperties } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'

export default class CareerRoutesDetailEmployer extends BaseModel {
  static override constructorName = 'CareerRoutesDetailEmployer'

  name: string = ''
  url: string = ''
  logo: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      this.logo = toCroppedImage(this.logo)
    }
  }
}
